import AttachFileIcon from '@mui/icons-material/AttachFile';
import { LoadingButton } from '@mui/lab';
import { FC, useRef, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { uploadFiles } from 'src/api/csApi';
import { Attachment } from 'src/models';

interface Props {
  newFile: (attachment: Attachment) => void;
}

export const UploadIcon: FC<Props> = ({ newFile }) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef();

  const changeHandler = async (event: any) => {
    try {
      if (event.target.files.length >= 1) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        setLoading(true);
        const res = await uploadFiles(formData);
        const attachment: Attachment = {
          type: file.name.split('.').pop() ?? '',
          name: file.name,
          fileType: file.type,
          url: res.data.data.url,
        };
        newFile(attachment);
        (ref as any).current.value = '';
      }
    } catch (e) {
      apiErrorHandling(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <input
        ref={ref as any}
        type="file"
        name="file"
        onChange={changeHandler}
        style={{
          display: 'none',
        }}
        multiple={false}
        accept="image/*, application/pdf"
      />
      <LoadingButton
        sx={{ border: 'none !important', minWidth: 'unset', width: 32, height: 32 }}
        loading={loading}
        color="inherit"
        variant="outlined"
        onClick={() => (ref?.current as any)?.click()}
      >
        <AttachFileIcon />
      </LoadingButton>
    </>
  );
};
